import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { OrderActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_order_detail() {
  while (true) {
    const action = yield take(OrderActionTypes.FETCH_ORDER_DETAIL);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/order/detail', type: 'POST', action, data: {
          ...options,
        },
        isloading:true,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;

        typeof onSuccess === 'function' && onSuccess(res.result);
        const orderExtraInfo = JSON.parse(result.orderExtraInfo||'{}');

        yield put({ type: OrderActionTypes.FETCH_ORDER_DETAIL_SUCCESS, data: {...result,orderExtraInfo} });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_order_detail--------' + error.message);
    }
  }
}

function* fetch_order_list() {
  while (true) {
    const action = yield take(OrderActionTypes.FETCH_ORDER_LIST);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/order/list/page', type: 'POST', action, data: {
          option: {
            isQueryGoods: true,
          },
          orderType: 'drugs',
          ...options,
        },
        isloading: true,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        const { result: { resultList = [], totalPage = 1 } = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        yield put({ type: OrderActionTypes.FETCH_ORDER_LIST_SUCCESS, data: resultList, totalPage, currentPage: options.currentPage });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_order_list--------' + error.message);
    }
  }
}

function* fetch_report_order_list() {
  while (true) {
    const action = yield take(OrderActionTypes.FETCH_REPORT_ORDER_LIST);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/order/list', type: 'POST', action, data: {
          option: {
            isQueryGoods: true,
          },
          orderType: 'drugs',
          ...options,
        },
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        typeof onSuccess === 'function' && onSuccess(result);
        yield put({ type: OrderActionTypes.FETCH_REPORT_ORDER_LIST_SUCCESS, data: result });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_order_list--------' + error.message);
    }
  }
}

function* cancel_order() {
  while (true) {
    const action = yield take(OrderActionTypes.CANCEL_ORDER);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/order/cancel', type: 'GET',
        action,
        isloading: true,
        data: {
          ...options,
        },
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        typeof onSuccess === 'function' && onSuccess(result);
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('cancel_order--------' + error.message);
    }
  }
}


export default function* root() {
  yield all([
    fork(fetch_order_detail),
    fork(fetch_order_list),
    fork(cancel_order),
    fork(fetch_report_order_list),
  ]);
}

